"use client";

import {useHydrateAtoms} from "jotai/utils";
import type {ReactNode} from "react";
import {cartHasCheckoutWarningAtom} from "./cartHasCheckoutWarning";
import {cartItemCountAtom} from "./cartItemCount";

export function HydrateCartItemCount({
	itemCount,
	hasCheckoutWarning,
	children,
}: {
	itemCount: number;
	hasCheckoutWarning: boolean;
	children: ReactNode;
}) {
	useHydrateAtoms([
		[cartItemCountAtom, itemCount],
		[cartHasCheckoutWarningAtom, hasCheckoutWarning],
	]);
	return children;
}
